import { createSelector } from '@reduxjs/toolkit';
import {
    selectConfigFromBootstrap,
    selectCurrencyCodeFromBootstrap,
    selectLocaleFromBootstrap,
    selectSessionId,
    selectUserIdFromBootstrap,
    selectCidFromBootstrap,
    selectBrowserInfoFromBootstrap,
    selectLanguageIdFromBootstrap,
    selectPageTypeIdFromBootstrap,
    selectMemberIdFromBootstrap,
} from 'store/slice/bootstrap';
import { clientVersion } from 'core-framework/constant/ApplicationInfo';
import { guid } from 'core-framework/util/CommonUtils';
import { OrchestrationServiceInfo, ApplicationName } from '@cart-js/core';
import { getForcedActivitiesGqlApiUrl, getForcedGatewayApiUrl, getForcedCartGatewayApiUrl, getForcedVehicleGqlApiUrl } from 'core/window/windowService';
import { origin } from 'core-framework/window/location';

export const selectServiceForCart = createSelector(selectConfigFromBootstrap, (configFromBootstrap) => {
    const wgUrl = configFromBootstrap.webgateUrl;
    const cartGatewayUrl = configFromBootstrap.cartGatewayUrl;
    const gatewayUrl = configFromBootstrap.gatewayUrl;
    const path = '';
    const graphQlSuffix = 'graphql';

    return {
        CartGateway: {
            baseUrl: getForcedCartGatewayApiUrl() ?? (cartGatewayUrl?.startsWith('/') ? cartGatewayUrl : `https://${cartGatewayUrl}`),
        },
        ActivitySearch: {
            baseUrl: getForcedActivitiesGqlApiUrl() ?? `${wgUrl}/${graphQlSuffix}${path}`,
        },
        Gateway: {
            baseUrl: getForcedGatewayApiUrl() ?? (gatewayUrl?.startsWith('/') ? gatewayUrl : `https://${gatewayUrl}`),
        },

        VehicleSearch: {
            baseUrl: getForcedVehicleGqlApiUrl() ?? `${origin()}/cars/${graphQlSuffix}`,
        },
    } as OrchestrationServiceInfo;
});

export const selectUserSetting = createSelector(
    selectCurrencyCodeFromBootstrap,
    selectLocaleFromBootstrap,
    selectLanguageIdFromBootstrap,
    selectMemberIdFromBootstrap,
    (currencyCode, locale, languageId, memberId) => ({
        currencyCode,
        languageId,
        language: locale,
        memberId,
    }),
);

export const selectClientInfo = createSelector(selectUserIdFromBootstrap, selectBrowserInfoFromBootstrap, selectPageTypeIdFromBootstrap, (userId, browserInfo, pageTypeId) => ({
    applicationName: browserInfo.isDesktop ? ApplicationName.DesktopWeb : ApplicationName.MobileWeb,
    clientVersion,
    userId: userId ?? '',
    requestId: guid(),
    pageTypeId: pageTypeId as number,
}));

export const selectSessionInfo = createSelector(selectSessionId, selectCidFromBootstrap, (sessionId: string, cid: number) => ({
    cid,
    id: sessionId,
    searchEngineClicks: {},
}));
